import React from 'react';

import type { ChangeEditionSectionMessageProps } from '../SectionMessage/ChangeEditionSectionMessage.tsx';
import { ConfluenceEdition } from '../Upgrade/__types__/waitForEditionChangeQuery.ts';
import { SectionMessage } from '../UpsellLooknFeel/SectionMessage.tsx';

type AdminKeyUpsellProps = Pick<ChangeEditionSectionMessageProps, 'body' | 'title'>;

export const AdminKeyUpsell = (props: AdminKeyUpsellProps): React.JSX.Element => (
	<SectionMessage
		upgradeEditionActionSubjectId="adminKeyUpsellUpgradeNow"
		learnMoreLink={{
			actionSubjectId: 'adminKeyUpsellLearnMore',
			inProductHelpId: '1ePHWZLYCbUCb5HG1OqZf2',
			inProductHelpTopic: 'admin-key-up-sell',
		}}
		source="superAdminUpsell"
		targetEdition={ConfluenceEdition.PREMIUM}
		{...props}
	/>
);
